import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { Observable, of } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ExpandComponent } from '../..';
import { NavigationMenuService } from '../../../services';
import { MenuItem, ElementTypes, GaContext } from '../../../interfaces';

@Component({
  selector: 'fin-section-navi',
  styleUrls: ['./section-navi.component.scss'],
  templateUrl: './section-navi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SectionNaviComponent {
  private navigationMenuService = inject(NavigationMenuService);

  readonly activeNaviItem$: Observable<MenuItem>;
  readonly activeNaviSection$: Observable<MenuItem>;
  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  @Input()
  title: string = null;

  @Input()
  showTitle$: Observable<boolean> = of(true);

  constructor() {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
    this.activeNaviItem$ = this.navigationMenuService.activeNaviItem;
  }

  trackByIndex(index: number): number {
    return index;
  }

  toggleDetails(expandComponent: ExpandComponent, external: boolean): void {
    if (!external) {
      expandComponent.toggleDetails();
    }
  }
}
